import { render, staticRenderFns } from "./TxListManage.vue?vue&type=template&id=114d47c3&scoped=true"
import script from "./TxListManage.vue?vue&type=script&lang=js"
export * from "./TxListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d47c3",
  null
  
)

export default component.exports